import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["select", "customRange"]

    toggle() {
        const isCustom = this.selectTarget.value === "custom";
        this.customRangeTarget.style.display = isCustom ? "flex" : "none";
    }
}
